export default __webpack_public_path__ + "static/media/about.a62691a9.jpg";